export const TrailerStatus = {
  ALL: 'None',
  LOADED: 'Loaded',
  EMPTY: 'Empty',
  PARTIAL: 'Partial',
  PRE_COOLING: 'PreCooling',
} as const;

export type TrailerStatus = (typeof TrailerStatus)[keyof typeof TrailerStatus];
